// SPDX-License-Identifier: AGPL-3.0-or-later

import Channels from '@app/features/channel/state/Channels';
import {noteRelocationRemoval, refillWindowAfterRelocation} from '@app/features/channel/state/RelocationRefill';
import ForumPosts from '@app/features/forum/state/ForumPosts';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import FavoritePreviews from '@app/features/messaging/state/FavoritePreviews';
import MessageReferences from '@app/features/messaging/state/MessageReferences';
import MessageReply from '@app/features/messaging/state/MessageReply';
import Messages from '@app/features/messaging/state/MessagingMessages';
import ReadStates from '@app/features/read_state/state/ReadStates';
import Notification from '@app/features/ui/state/Notification';

interface MessageDeleteBulkPayload {
	channel_id: string;
	ids: Array<string>;
}

export function handleMessageDeleteBulk(data: MessageDeleteBulkPayload, _context: GatewayHandlerContext): void {
	noteRelocationRemoval(data.channel_id, data.ids);
	Messages.handleMessageDeleteBulk({channelId: data.channel_id, ids: data.ids});
	// LOCAL-ONLY (favorites-bookmarks-plan.md section 3): a favorite's previewed message among them, or a relocation's
	// notice (no ids): that channel is fetched again.
	FavoritePreviews.handleMessageDeleteBulk(data.channel_id, data.ids);
	// LOCAL-ONLY (relocation-plan.md section 17): a bulk removal in the open channel (a relocation from this or another
	// device) fetches the loaded span again, so no gap is left. Exclude from upstream sync.
	void refillWindowAfterRelocation(data.channel_id);
	Channels.handleThreadMessageDeleteBulk(data.channel_id, data.ids);
	for (const id of data.ids) ForumPosts.handleMessageDelete(data.channel_id, id);
	MessageReferences.handleMessageDeleteBulk(data.channel_id, data.ids);
	MessageReply.handleMessageDeleteBulk(data.channel_id, data.ids);
	// LOCAL-ONLY (relocation-plan.md section 19): an empty list is a relocation's notice to its destination (messages
	// arrived, nothing was deleted), so read state and notifications are left as they are. Exclude from upstream sync.
	if (data.ids.length === 0) return;
	ReadStates.handleMessageDelete({channelId: data.channel_id});
	Notification.handleMessageDelete({channelId: data.channel_id});
}
